<template>
    <main id="main" class="main-site">
        <div class="container">
            <div class="wrap-breadcrumb">
                <ul>
                    <li class="item-link">
                        <router-link to="/loja" class="fa fa-home"></router-link>
                    </li>
                    <li class="item-link">
                        <router-link to="/loja/minha-conta"><span>Minha Conta</span></router-link>
                    </li>
                    <li class="item-link">
                        <span>Portal Crazy Card</span>
                    </li>
                </ul>
            </div>
            <div class="main-content-area">
                <div class="row" style="margin-bottom: 30px">
                    <div class="col-xs-12">            
                        <img width="1170" height="281" src="https://www.aldo.com.br/assets/images/portal-crazy-card.jpg" alt="Portal Crazy Card"/>                              
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-xs-12 col-sm-4">
                    <div class="aboutus-info style-small-left">
                        <b class="box-title">Crazy tools</b>
                        <div class="txt-content">
                            <p><a :href="`${$SiteUrl}/loja/crazy-card/extrato`"><i class="fa fa-arrow-right"></i> Extrato</a></p>
                            <p> <a :href="`${$SiteUrl}/loja/crazy-card/resgate`"><i class="fa fa-arrow-right"></i> Resgate</a></p>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-4">
                    <div class="aboutus-info style-small-left">
                        <b class="box-title">Aldo Mega Store</b>
                        <div class="txt-content">
                            <p v-for="(cat, index) in categorias" :key="index"><a v-bind:href="`${$SiteUrl}/loja/crazy-card/categoria/`+ cat.id"><i class="fa fa-arrow-right"></i> {{cat.name}}</a></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>

export default {
    name: "PortalCrazyCard",
    mounted() {
        const self = this;
        $.ajax({
            url: this.$apiUrl + "Session.svc/getsessions",
            dataType: "json",
            type: "GET",
            xhrFields: { withCredentials: true },
            error: () => {
                swal({
                    title: "É necessário estar logado",
                    icon: "warning"
                }).then(() => location.href = `${self.$SiteUrl}/login?redirectTo=` + location.href)
            }
        });
    },
    data() {
    return {
      categorias : [
        // {
        //   id : 0,
        //   name :'Showroom'
        // },
        {
          id : 5,
          name :'Produtos e Utilitários'
        }
        // {
        //   id : 11,
        //   name :'Ferramentas'
        // },
        
        // {
        //   id : 4,
        //   name :'Brindes'
        // }
        //,
        //{
        //  id : 2,
        //  name :'Treinamentos e Eventos'
        //}
      ]
    };
  }    
}
</script>